import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {useSubscription} from "../subscription/useSubscription";
import ideaActionsFactory from "../idea/ideaActions";
import ActivityRow from "../idea/ActivityRow";
import AuthorAction from "./AuthorAction";
import IdeaDetailsModal from "../idea/modal/IdeaDetailsModal";
import {ActivityBreakdown} from "./ActivityBreakdown";
import PageSection from "../elements/PageSection";
import SubHeading from "../elements/SubHeading";
import TableContainer from "../elements/TableContainer";
import {CentredLoader} from "../elements/Loader";
import {AuthorPageHeader} from "./header/AuthorPageHeader";
import AuthorOpenIdeas from "./ideas/AuthorOpenIdeas";
import {logAction} from "../../logging/logEvent";

const defaultActivityLimit = 50;

const AuthorPageWrapper = ({activityLimit = defaultActivityLimit}) => {
    const {authorId} = useParams();
    useSubscription("AUTHOR", `/ui/api/authors/${authorId}`, 60);
    const authorDetails = useSelector(state => state.singleAuthor);

    if (authorDetails.authorId !== authorId) {
        return <div style={{padding: 20}}><CentredLoader /></div>;
    }

    return <AuthorPage authorDetails={authorDetails} activityLimit={activityLimit}/>
};

const AuthorPage = ({authorDetails, activityLimit}) => {
    const dispatch = useDispatch();
    const ideaActions = ideaActionsFactory(dispatch);
    useEffect(() => {
        logAction({
            type: "Contributor Page Visited",
            authorId: authorDetails.authorId,
            authorName: authorDetails.authorName,
        });
        return () => {};
    }, []);

    const activityRows = authorDetails.activity.slice(0, activityLimit).map((action, index) =>
        <ActivityRow dateTime={action.dateTime} action={action.action} key={index} onClick={() => ideaActions.showDetail(action.ideaId)}>
            <AuthorAction {...action} />
        </ActivityRow>
    );

    return <div>
        <AuthorPageHeader authorDetails={authorDetails}/>
        <PageSection>
            <div style={{display: "flex"}}>
                <div style={{width: 320, marginRight: 20}}>
                    <AuthorOpenIdeas ideaActions={ideaActions} authorDetails={authorDetails}/>
                </div>
                <div style={{width: 780, marginRight: 20}}>
                    <TableContainer>
                        <SubHeading>Activity</SubHeading>
                        {activityRows}
                    </TableContainer>
                </div>
                <div style={{width: 500, marginRight: 20}}>
                    <TableContainer>
                        <ActivityBreakdown breakdown={authorDetails.breakdown}/>
                    </TableContainer>
                </div>
            </div>
        </PageSection>
        <IdeaDetailsModal />
    </div>;
};

export default AuthorPageWrapper;
